import { render, staticRenderFns } from "./BCjinCang.vue?vue&type=template&id=1e7d520c&"
import script from "./BCjinCang.vue?vue&type=script&lang=js&"
export * from "./BCjinCang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports